import { API } from "../auth/authApi";

export const getConferenceAgendaApi = (params) => {
    return API.get("/conference-agenda", { params });
};

export const createConferenceAgendaApi = (data) => {
    return API.post("/conference-agenda", data, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};

export const updateConferenceAgendaApi = (id, data) => {
    return API.put(`/conference-agenda/${id}`, data, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};

export const deleteConferenceAgendaApi = (id) => {
    return API.delete(`/conference-agenda/${id}`);
};